<template>
    <Transition name="pop">
        <div id="resultPop" class="pop" v-if="state.show">
            <div class="content">
                <span class="close" @click="state.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>恭喜您抽中</h1>
                <div class="img-wrapper">
                    <img :src="state.reward.icon" alt="" />
                </div>
                <h2>{{ state.reward.name }}</h2>
                <div class="btn-confirm" @click="state.show = false">确认</div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { reactive } from "vue";

const state = reactive({
    show: false,
    reward: {}
});

defineExpose({
    Show(reward) {
        state.reward = reward;
        state.show = true;
    }
});
</script>

<style lang="scss" scoped>
#resultPop {
    .img-wrapper {
        width: 300px;
        margin: 0px auto;
        display: flex;
        justify-content: center;
        img {
            width: 100%;
        }
    }
    h2 {
        text-align: center;
        margin-bottom: 20px;
    }
    .btn-confirm {
        width: 240px;
        height: 50px;
        margin: 0px auto 10px auto;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;
        background: linear-gradient(to bottom, #86362c, #d6584b);
    }
}
</style>
